<h2 mat-dialog-title class="apifailure_header">{{data?.headline}}</h2>
@if(currentSite == 'seqirusb2b-uk'){
  <mat-dialog-content class="apifailure_content" [innerHTML]="data?.content">
  </mat-dialog-content>
}
@if(currentSite == 'seqirusb2b-flu360'){
  <mat-dialog-content class="apifailure_contentUS" [innerHTML]="data?.message1">
  </mat-dialog-content>
}

<mat-dialog-actions align="end">
  <button mat-button class="global_greybtn" (click)="close()">{{data?.button}}</button>
</mat-dialog-actions>

@if (currentSite == 'seqirusb2b-uk') {
  <div class="apipopupjobcode">{{data?.jobBagCode}}</div>
}